<ul [class.parent]="!child" class="comments-block">
    @for (comment of comments; track comment) {
        <li>
            <app-comment [child]="child" [comment]="comment" [post]="post"></app-comment>
            @if (!comment.minimiseReplies) {
                <div class="commentReplies">
                    <app-comments-list [child]="true" [comments]="comment.children"
                                       [post]="post"></app-comments-list>
                </div>
            }
        </li>
    }
</ul>
